import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/bricks';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  column-count: 2;
  column-gap: ${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    column-count: 4;
    column-gap: ${theme.spaceUnits.desktop.SMALL};
  }
`;

export const link: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.neutrals.darkest};
  text-decoration: underline;
  display: block;
  break-inside: avoid;
`;
